import { render, staticRenderFns } from "./CredentialDesign.vue?vue&type=template&id=4cc31ae4"
import script from "./CredentialDesign.vue?vue&type=script&lang=js"
export * from "./CredentialDesign.vue?vue&type=script&lang=js"
import style0 from "./CredentialDesign.vue?vue&type=style&index=0&id=4cc31ae4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports